<template>
  <v-row no-gutters>
    <v-col class="px-2">
      <template v-for="(item, n) in log">
        <v-row :key="n" no-gutters>
          <v-col>
            <v-alert
              dense
              border="left"
              colored-border
              color="secondary"
              elevation="3"
              class="py-0 pr-1"
            >
              <v-row justify="end">
                <v-responsive
                  height="12"
                  max-width="60"
                  style="font-size: 9.5px"
                  class="text-center text-uppercase amber darken-3 white--text rounded-0 font-weight-bold"
                  >{{ item.entity }}</v-responsive
                >

                <v-responsive
                  height="12"
                  max-width="50"
                  style="font-size: 9.5px"
                  class="text-center text-uppercase accent white--text rounded-0 font-weight-bold"
                  >{{ item.event }}</v-responsive
                >
              </v-row>

              <v-row>
                <span class="caption">{{ item.message }}</span>
              </v-row>

              <v-row justify="end">
                <span class="overline mr-4">{{ item.datetime }}</span>
                <span style="font-size: 10px" class="ml-4">{{
                  item.sender_first_name
                }}</span>
              </v-row>
            </v-alert>
          </v-col>
        </v-row>
        <v-divider :key="`${n}divider`" class="my-1"></v-divider>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import constant from "../../const";
import axios from "axios";
import moment from "moment";
export default {
  props: ["quotation_id"],
  data() {
    return {
      CONSTANT: constant,
      log: [],
    };
  },
  created() {},
  mounted() {
    this.fetchLog();
  },
  watch: {},
  methods: {
    /**
     * Fetch quotation log from bigquery
     */
    async fetchLog() {
      // this.$root.blockUImsg = "loading log..."
      // this.$root.blockUIshow = true
      try {
        // get today's date
        let today = moment().add("1", "days").format("YYYY-MM-DD");
        // compose the url query
        let url = `https://asia-northeast1-af-cloud-notifications.cloudfunctions.net/fetch_activity_log?quotation_id=${this.quotation_id}&date_filter=${today}`;

        // await for a gte request
        let resp = await axios.get(url);

        if (resp.data.status == "OK") {
          this.log = resp.data.data;
        } else {
          this.log = [];
        }
      } catch (error) {
        this.log = [];
        this.$root.blockUIshow = false;
      }
      this.$root.blockUIshow = false;
    },
  },
  computed: {},
};
</script>

<style scoped>
.v-chip.v-size--x-small.chip-x-small-custom-1 {
  font-size: 8.5px;
  height: 11.5px;
  width: 55px;
}
</style>
